import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, messageErreur } from "@/lib/api";
import { FormulaireMotDePasse } from "@/components/FormulaireMotDePasse";

export default function Invitation() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [erreur, setErreur] = useState("");

  useEffect(() => {
    api.get(`/invitations/${token}`).then((r) => setInfo(r.data)).catch((e) => setErreur(messageErreur(e)));
  }, [token]);

  const valider = async (mot_de_passe) => {
    try {
      const { data } = await api.post(`/invitations/${token}/accepter`, { mot_de_passe });
      setUser(data);
      toast.success("Bienvenue sur Airthermo V2 !");
      navigate("/");
    } catch (e) { throw new Error(messageErreur(e)); }
  };

  if (!info && !erreur) return null;
  return (
    <FormulaireMotDePasse
      erreurExterne={erreur}
      titre={info ? `Bonjour ${info.prenom}` : ""}
      sousTitre={info ? `Vous rejoignez Airthermo V2 avec le profil « ${info.role_label} » (${info.email}). Choisissez votre mot de passe.` : ""}
      bouton="Activer mon compte"
      onValider={valider}
    />
  );
}
